// extracted by mini-css-extract-plugin
module.exports = {"image":"Species_image__DidW_","species":"Species_species__hA6E9","buttons":"Species_buttons__1qW7R","name":"Species_name__KfoAo","sciName":"Species_sciName__3TmRn"};